import { useBottomSheetModal } from '@gorhom/bottom-sheet'
import React, { useMemo } from 'react'
import { StyleSheet, TouchableOpacity } from 'react-native'
import { v4 as uuidv4 } from 'uuid'

import { Box } from 'widgets/Box'
import { Image } from 'widgets/Image'
import { Text } from 'widgets/Text'

import { useSubscribed } from 'hooks/useSubscribed'
import { useUser } from 'hooks/useUser'

import { links } from 'utils/constants'

import { useFocusMode } from 'contexts/FocusModeContext'

import { Program } from 'types/program'

type ProgramItemProps = {
  program: Program
  navigation: any
}

export const ProgramItem = ({ program, navigation }: ProgramItemProps) => {
  const bottomSheet = useBottomSheetModal()

  const styles = StyleSheet.create({
    squareContainer: {
      borderRadius: 5,
    },
    squareImage: {
      width: 80,
      height: 80,
      borderRadius: 5,
    },
  })

  const { data: trainer } = useUser({ userId: program.trainer.id })
  const title = useMemo(
    () => program?.title ?? `${trainer?.firstName} ${trainer?.lastName}'s Group`,
    [program?.title, trainer?.firstName, trainer?.lastName],
  )
  const avatar = useMemo(
    () => program?.cover ?? trainer?.avatar ?? { url: '', mimeType: '', _original: {} },
    [program?.cover, trainer?.avatar],
  )

  const focusMode = useFocusMode()
  const { isSubscribed } = useSubscribed({ programId: program?.id })

  const handlePress = () => {
    bottomSheet.dismiss()
    if (isSubscribed) {
      focusMode.setGroup(program)
      return
    }
    navigation.navigate(links.GROUP_STACK, {
      screen: links.GROUP_PAGE,
      params: { username: trainer?.username },
    })
  }

  return (
    <Box
      width={90}
      display='flex'
      flexDirection='column'
      align='center'
      justifyContent='flex-start'
      margin={{ horizontal: 'sm' }}
      backgroundColor='white'
      testID={`UpspaceItem-${program?.id}`}
    >
      <TouchableOpacity onPress={handlePress}>
        <Box
          margin={{ horizontal: 'xs', top: 12, bottom: 16 }}
          padding='xxs'
          style={styles.squareContainer}
        >
          <Image
            cacheKey={
              program
                ? // eslint-disable-next-line no-underscore-dangle
                  `${program?.id}-program-cover-${program?.cover?._original?.etag}-small`
                : uuidv4()
            }
            imageWidth={160}
            resizeMode='cover'
            style={styles.squareImage}
            source={{
              uri: avatar?.url,
            }}
          />
        </Box>
        <Box>
          <Text bold align='center' fontSize='xs' color='v2black' numberOfLines={2}>
            {title}
          </Text>
          <Text align='center' fontSize='xs' color='v2black' numberOfLines={2}>
            {trainer?.username}
          </Text>
        </Box>
      </TouchableOpacity>
    </Box>
  )
}
